import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import { useFieldArray, useForm } from "react-hook-form";
import {generosPersona,TIPO_ADMISION_B,TITULO_EST_REG,} from "../../../utils/constantes";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormInput } from "../../../components/molecules/FormInput";
import { FormSelect } from "../../../components/atoms/FormSelect";
import { getAllPaises } from "../../../services/pais.service";
import { getAllProvinciasByIdDepartamento } from "../../../services/provincia.service";
import { getAllDepartamentosByIdPais } from "../../../services/departamento.service";
import { getAllNiveles, getAllNivelesByIdIdioma } from "../../../services/nivel.service";
import { getAllIdiomas, getAllIdiomasByIdNivel } from "../../../services/idioma.service";
import { getAllModulosByIdNivelAndIdIdioma } from "../../../services/modulo.service";
import { getAllProgramasByIdIdioma } from "../../../services/programa.service";
import { FormHook } from "../../../components/molecules/FormHook";
import { showAlert, showErrorAlert, showUpdateCreditoAlert } from "../../../components/molecules/ShowAlert";
import { crearPersona } from "../../../services/persona.service";
import { crearEstudiante } from "../../../services/estudiante.service";
import { crearEleccionIdioma } from "../../../services/eleccionIdioma";
import { getAllTipoAdmisiones } from "../../../services/tipoAdmision.service";
import { crearInscripcion } from "../../../services/inscripcion.service";
import { SubmitButton } from "../../../components/atoms/SubmitButton";

export const RegistrarEstudiantePage = () => {
  const navigate = useNavigate();
  const [pagina, setPagina] = useState(1);
  const [generos, setGeneros] = useState(generosPersona);
  const [paises, setPaises] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [tipoAdmisiones, setTipoAdmisiones] = useState([]);
  const [tipoAdmision, setTipoAdmision] = useState("");
  const [estaCargando, setEstaCargando] = useState(false);
  const [idiomas, setIdiomas] = useState([]);
  const DIR_ICONO_EST = "/img/iconos/estudiante_que_va_en_medio.svg";

  const {
    handleSubmit,
    register,
    control,
    formState: { errors }, watch,
    trigger,
  } = useForm({
    defaultValues: {
      planesEstudio: [{ idNivel: null, idIdioma: null, idModulo: null }],
      idPrograma: null
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "planesEstudio"
  });

  const obtenerPaises = async () => {
    await getAllPaises().then((paises) => {
      setPaises(paises?.map((pais) => ({
        value: pais?.idPais,
        label: pais?.nombre,
      })));
    }).catch((err) => console.log(err));
  };

  const handleGetDepartamentosByIdPais = async (data) => {
    await getAllDepartamentosByIdPais(data.value)
      .then((departamentos) =>
        setDepartamentos(departamentos?.map((departamento) => ({
          value: departamento?.idDepartamento,
          label: departamento?.nombre,
        })))
      )
      .catch((err) => console.log(err));
  };

  const handleGetProvinciasByIdDepartamento = async (data) => {
    await getAllProvinciasByIdDepartamento(data?.value)
      .then((provincias) => setProvincias(provincias?.map((provincia) => ({
        value: provincia?.idProvincia,
        label: provincia?.nombre,
      }))))
      .catch((err) => console.log(err));
  };

  const handleTipoAdmisionChange = async (data) => {
    setTipoAdmision(data.label)
  };

  const obtenerTipoAdmisiones = async () => {
    await getAllTipoAdmisiones()
      .then((admisiones) =>
        setTipoAdmisiones(admisiones?.map((admision) => ({
          value: admision?.idTipoAdmision,
          label: admision?.nombre,
        })))
      )
      .catch((err) => console.log(err));
  }

  const obtenerIdiomas = async () => {
    await getAllIdiomas()
      .then((idiomas) =>
        setIdiomas(idiomas?.map((idioma) => ({
          value: idioma?.idIdioma,
          label: idioma?.nombre,
        })))
      )
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    obtenerPaises();
    obtenerTipoAdmisiones()
    obtenerIdiomas()
  }, []);

  const handlePage1Next = async () => {
    const result = await trigger([
      "nombre",
      "apellido",
      "celular",
      "sexo",
      "tipoAdmision",
      "pais",
      "idDepartamento",
      "credito",
    ]);
    if (result) {
      setPagina(2);
    }
  };

  const submit = async (data) => {
    if (pagina !== 2) {
      setPagina(pagina + 1);
      return;
    }
    setEstaCargando(true);

    if (!data?.idDepartamento?.value) {
      showErrorAlert({ text: "Debe seleccionar un departamento válido." });
      setEstaCargando(false);
      return;
    }

    if (!data?.sexo?.value) {
      showErrorAlert({ text: "Debe seleccionar un género válido." });
      setEstaCargando(false);
      return;
    }

    if (!data?.tipoAdmision?.value) {
      showErrorAlert({ text: "Debe seleccionar un tipo de admisión válido." });
      setEstaCargando(false);
      return;
    }

    const dataPersona = {
      nombre: data.nombre,
      apellido: data.apellido,
      celular: data.celular,
      correo: data?.correo?.trim() ? data.correo.trim() : null,
      ci: data?.ci?.trim() ? data.ci.trim() : null,
      fechaNacimiento: data?.fechaNacimiento ? data.fechaNacimiento : null,
      idDepartamento: data.idDepartamento?.value,
      idProvincia: data?.idProvincia?.value ? data.idProvincia.value : null,
      sexo: data.sexo.value,
      anioAdmision: data?.anioAdmision ? data.anioAdmision : null,
    };

    try {
      const nuevaPersona = await crearPersona(dataPersona);
      const dataEstudiante = {
        idPersona: nuevaPersona?.persona.idPersona,
        organizacionSocial: data.organizacionSocial,
        idTipoAdmision: data.tipoAdmision.value,
        credito: data.credito || 0,

      };

      const nuevoEstudiante = await crearEstudiante(dataEstudiante);
      const dataInscripcion = {
        descripcion: data?.descripcion?.trim() ? data.descripcion.trim() : "",
        idPrograma: data?.idPrograma?.value ? data.idPrograma.value : null,
        idEstudiante: nuevoEstudiante.idEstudiante,
      };

      const nuevaInscripcion = await crearInscripcion(dataInscripcion)
      const promesasEleccionIdioma = data.planesEstudio.map(async (plan) => {
        const dataEleccionIdioma = {
          idInscripcion: nuevaInscripcion.idInscripcion,
          idIdioma: plan.idIdioma.value,
          idModulo: plan.idModulo.value
        }
        return await crearEleccionIdioma(dataEleccionIdioma)
      });
      await Promise.all(promesasEleccionIdioma);
      showAlert({
        text: `Nuevo estudiante con código: ${nuevaPersona?.usuario?.username}.`,
        callback: () => {
            if (
            data.tipoAdmision.label === "Regular" && 
            data.credito > 0
          ) {
            showUpdateCreditoAlert({
              text: "Porque el estudiante está registrado como Regular. Si deseas modificar el crédito, cambia el tipo de admisión a Becario.",
              callback: () => {
                navigate("/estudiantes");
              },
            });
          } else {
            navigate("/estudiantes"); 
          }
        },
      });
    } catch (err) {
      const errorData = err?.response?.data;
      const modelStateErrors =
        errorData && typeof errorData === "object" && !Array.isArray(errorData)
          ? Object.values(errorData)
              .flatMap((v) => (Array.isArray(v) ? v : []))
              .filter(Boolean)
          : [];
      const errorMessage =
        errorData?.message ||
        (Array.isArray(errorData?.errors) ? errorData.errors.join(", ") : null) ||
        (modelStateErrors.length > 0 ? modelStateErrors.join(", ") : null) ||
        (typeof errorData === "string" ? errorData : null) ||
        "No se pudo registrar el estudiante. Verifique los datos requeridos.";
      showErrorAlert({ text: errorMessage });
      console.log(err);
    } finally {
      setEstaCargando(false);
    }
  };

  const pagina1 = (
    <>
      <FormDiv className="md:flex flex-wrap">
        <FormInput
          id="nombre"
          label="Nombre"
          type="text"
          placeholder="Nombre"
          register={register}
          validation={{
            required: { value: true, message: "Campo requerido" },
            maxLength: { value: 50, message: "Súpero la cantidad máxima 50 caracteres" },
            minLength: { value: 1, message: "Mínimo 1 caracter" },
          }}
          error={errors.nombre}
          className="md:w-1/2 md:pr-2"
        />

        <FormInput
          id="ci"
          label="Cédula de identidad"
          type="text"
          placeholder="Cédula de identidad"
          register={register}
          validation={{
            maxLength: { value: 15, message: "Súpero la cantidad máxima 15 caracteres" },
            minLength: { value: 3, message: "Mínimo 3 caracteres" }
          }}
          className="md:w-1/2 md:pl-2"
        />
        <FormInput
          id="apellido"
          label="Apellido"
          type="text"
          placeholder="Apellido"
          register={register}
          validation={{
            required: { value: true, message: "Campo requerido" },
            maxLength: { value: 50, message: "Súpero la cantidad máxima 50 caracteres" },
            minLength: { value: 1, message: "Mínimo 1 caracter" },
          }}
          error={errors.apellido}
          className="md:w-1/2 md:pr-2"
        />

        <FormInput
          id="correo"
          label="Correo"
          type="text"
          placeholder="Correo electronico"
          register={register}
          validation={{
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo invalido, (caracteres necesarios "@, .com")'
            },
            maxLength: { value: 100, message: "Súpero la cantidad máxima 100 caracteres" },
            minLength: { value: 5, message: "Mínimo 5 caracteres" },
          }}
          error={errors.correo}
          className="md:w-full"
        />

        <FormInput
          id="celular"
          label="Número teléfono"
          type="text"
          placeholder="Número teléfono"
          register={register}
          validation={{
            required: { value: true, message: "Campo requerido" },
            maxLength: { value: 15, message: "Súpero la cantidad máxima 15 caracteres" },
            minLength: { value: 6, message: "Mínimo 6 caracteres" },
          }}
          error={errors.celular}
          className="md:w-1/2 md:pr-2"
        />
        <FormInput
          id="fechaNacimiento"
          label="Fecha de Nacimiento"
          type="date"
          register={register}
          error={errors.fechaNacimiento}
          className="md:w-1/2 md:pl-2"
        />

        <FormSelect
          name="tipoAdmision"
          label="Modo admisión"
          control={control}
          options={tipoAdmisiones}
          isMulti={false}
          validation={{ required: "Campo requerido" }}
          placeholder="Seleccione un modo"
          handleChange={handleTipoAdmisionChange}
          error={errors.tipoAdmision}
          className="md:w-1/2 md:pr-2"
        />

        <FormInput
          id="organizacionSocial"
          label="Miembro en"
          type="text"
          placeholder="Miembro en"
          register={register}
          className="md:w-1/2 md:pl-2"
        />

        <FormInput
          id="anioAdmision"
          label="Fecha de ingreso"
          type="date"
          register={register}
          className="md:w-1/2 md:pr-2"
        />
        <FormSelect
          name="sexo"
          label="Género"
          control={control}
          options={generos}
          isMulti={false}
          validation={{ required: "Campo requerido" }}
          placeholder="Seleccione un género"
          error={errors.sexo}
          className="md:w-1/2 md:pl-2"
        />

        <FormInput
          id="credito"
          label="Crédito "
          type="number"
          placeholder="Ingrese el crédito del estudiante becario (si es estudiante regular poner 0)"
          register={register}
          validation={{
            required: { value: true, message: "Campo requerido" },
            min: { value: 0, message: "El crédito debe ser positivo" },
            max: { value: 100, message: "Máximo 100 créditos" },
          }}
          error={errors.credito}
          className="md:w-1/2 md:pl-2"
        />

      </FormDiv>
      <FormDiv className="md:flex">
        <FormSelect
          name="pais"
          label="País "
          control={control}
          options={paises}
          isMulti={false}
          validation={{ required: "Campo requerido" }}
          placeholder="Seleccione un país"
          handleChange={handleGetDepartamentosByIdPais}
          error={errors.pais}
          className="md:w-1/2 md:pr-2"
        />
        <FormSelect
          name="idDepartamento"
          label="Departamento"
          control={control}
          options={departamentos}
          isMulti={false}
          validation={{ required: "Campo requerido" }}
          placeholder="Seleccione un departamento"
          handleChange={handleGetProvinciasByIdDepartamento}
          error={errors.idDepartamento}
          className="md:w-1/2 md:px-2"
        />
        <FormSelect
          name="idProvincia"
          label="Provincia"
          control={control}
          options={provincias}
          isMulti={false}
          placeholder="Seleccione una provincia"
          className="md:w-1/2 md:px-2"
        />
      </FormDiv>
      <div className="mx-auto md:flex mt-2">
        <div className="md:w-full">
          <button
            className="bg-blue-700 md:w-full text-white font-bold py-2 px-4 transition-colors hover:bg-blue-800 rounded-lg"
            onClick={handlePage1Next}
          >
            Siguiente
          </button>
        </div>
      </div>
    </>
  );



  const PlanEstudio = ({ index }) => {
    const [idIdioma, setIdIdioma] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [niveles, setNiveles] = useState([]);

    const [programas, setProgramas] = useState([]);

    const handleGetNivelesByIdIdiomaChange = async (data) => {
      setIdIdioma(data.value)
      await getAllNivelesByIdIdioma(data.value)
        .then((niveles) => setNiveles(niveles?.map((nivel) => ({
          value: nivel?.idNivel,
          label: nivel?.nombre,
        }))))
        .catch((err) => console.log(err));
      await getAllProgramasByIdIdioma(data.value)
        .then((programas) =>
          setProgramas(programas?.map((programa) => ({
            value: programa?.idPrograma,
            label: programa?.nombre,
          })))
        )
        .catch((err) => console.log(err));
    }

    const handleGetModulosByIdNivelAndIdIdiomaChange = async (data) => {
      await getAllModulosByIdNivelAndIdIdioma(data.value, idIdioma)
        .then((modulos) =>
          setModulos(modulos?.map((modulo) => ({
            value: modulo?.idModulo,
            label: modulo?.nombre,
          })))
        )
        .catch((err) => console.log(err));
    };
    return (
      <>
        <FormDiv className="flex flex-wrap mb-4 border border-slate-300 p-2 rounded-lg">
          <FormSelect
            name={`planesEstudio.${index}.idIdioma`}
            label="Idiomas"
            control={control}
            options={idiomas}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un idioma"
            handleChange={handleGetNivelesByIdIdiomaChange}
            error={errors.planesEstudio?.[index]?.idIdioma}
            className="w-full md:w-1/3 px-2 mb-2"
          />
          <FormSelect
            name={`planesEstudio.${index}.idNivel`}
            label="Niveles"
            control={control}
            options={niveles}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un nivel"
            handleChange={handleGetModulosByIdNivelAndIdIdiomaChange}
            error={errors.planesEstudio?.[index]?.idNivel}
            className="w-full md:w-1/3 pr-2 mb-2"
          />
          <FormSelect
            name={`planesEstudio.${index}.idModulo`}
            label="Módulos"
            control={control}
            options={modulos}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un módulo"
            error={errors.planesEstudio?.[index]?.idModulo}
            className="w-full md:w-1/3 pl-2 mb-2"
          />
          {index > 0 && (
            <button
              type="button"
              onClick={() => remove(index)}
              className="m-auto p-2 px-4 bg-red-500 text-white rounded"
            >
              Eliminar nuevo plan
            </button>
          )}
        </FormDiv>
        {(index < 1 && tipoAdmision === TIPO_ADMISION_B) && <FormSelect
          name="idPrograma"
          label="Programa"
          control={control}
          options={programas}
          placeholder="Seleccione un programa"
          error={errors.idPrograma}
          className="w-full md:w-1/2 mb-4"
        />}
      </>
    );

  };

  const addNuevoPlan = () => {
    append({ idNivel: null, idIdioma: null, idModulo: null });
  };

  const pagina2 = (
    <>
      {fields.map((field, index) => (
        <PlanEstudio key={field.id} index={index} />
      ))}
      <button
        type="button"
        onClick={addNuevoPlan}
        className="bg-blue-500 text-white p-2 rounded mt-2 mb-4"
      >
        Agregar Nuevo Plan de Estudio
      </button>
      <div className="mx-auto mt-2 w-full flex justify-end">
        <div className="flex gap-4 flex-col md:flex-row">
          <div className="mt-4 flex">
            <button
              className="mx-auto p-2 px-4 rounded-md bg-yellow-500 transition-all hover:bg-yellow-600 text-white font-medium text-lg"
              onClick={() => setPagina(1)}
            >
              Anterior
            </button>
          </div>
          <SubmitButton estaCargando={estaCargando} text="Guardar" />
        </div>
      </div>
    </>
  );
  return (
    <ContenedorPageTemplate dirIcono={DIR_ICONO_EST} titulo={TITULO_EST_REG}>
      <FormHook handleSubmit={handleSubmit}
        submit={submit}>

        {pagina === 1 && pagina1}
        {pagina === 2 && pagina2}

      </FormHook>
      <div id="resultado"></div>
    </ContenedorPageTemplate>
  );
};
